<template>
  <div id="import-calendar">
    <b-card class="card-upload">
      <div class="import-calendar-header">
        <b-button
          variant="flat-primary"
          size="sm"
          class="btn-close"
          @click="$emit('close')"
        >
          <feather-icon icon="XIcon" />
        </b-button>
        <h4>{{$t('IMPORT_CALENDAR.Import_Calendar')}}</h4>
      </div>
      <div class="import-calendar-row">

        <div class="import-calendar-functions">
          <b-button
            variant="primary"
            class="btn-submit-events"
            block
            @click="onSubmit"
            :disabled="events.length === 0"
          >
            {{$t('IMPORT_CALENDAR.Send_Events')}}
          </b-button>
          <div class="drag-files" @dragover="dragover" @dragleave="dragleave" @drop="drop">
            <b-button
              aria-controls="sidebar-add-new-event"
              v-ripple.400="'rgba(40, 199, 111, 0.15)'"
              variant="flat-primary btn-upload"
              class="btn-icon"
              block
              @click="openSelectFile"
            >
              <feather-icon icon="UploadIcon" />
            </b-button>
            <span class="text-btn">{{$t('IMPORT_CALENDAR.Select')}}</span>
            <input
              type="file"
              ref="fileImage"
              accept=".ics"
              style="display: none"
              :multiple="false"
              @change="onSelectedFile"
            />
          </div>
        </div>
        <div class="event-list">
          <b-overlay class="custom-overlay" :show="displayOverlay" rounded="sm">
            <b-list-group>
              <b-list-group-item v-for="(event, index) in events" :key="index">
                <div class="event-list-item">
                  <div style="display: flex; align-items: center;">

                    <div
                      class="event-conflict-alert"
                      v-if="event.hasConflict"
                    >
                      <feather-icon icon="AlertTriangleIcon"/>
                    </div>
                    <div class="event-info">
                      <strong class="event-info-title">{{ event.summary }}</strong>
                      <br>
                      <span>{{ event.startDate.toLocaleString() }} - {{ event.endDate.toLocaleString() }}</span>
                      <br>
                      <strong 
                        v-if="event.location != null" 
                        style="padding-left: 7px; padding-top: 7px; padding-bottom: 7px;"
                      >
                        {{ `${$t('IMPORT_CALENDAR.Location')}:`}}
                      </strong>
                      <span v-if="event.location != null">{{ event.location }}</span>
                    </div>
                  </div>
                  <div>
                    <b-button 
                    style="margin-right: 15px;"
                      variant="primary"
                      size="sm" 
                      v-if="event.hasConflict"
                      @click="event.showConflicts = !event.showConflicts"
                    >
                      {{ event.showConflicts ? `${$t('IMPORT_CALENDAR.Show_Conflicting_Events')}:` : `${$t('IMPORT_CALENDAR.Hide_Conflicting_Events')}:` }}
                    </b-button>
                    <b-button
                      variant="danger"
                      size="sm"
                      class="btn-delete"
                      @click="deleteEvent(index)"
                      :title="$t('IMPORT_CALENDAR.Delete_Event')"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                  <!-- <div 
                    class="event-conflict-alert"
                    v-if="event.hasConflict"
                  >
                    <b-button 
                      variant="primary"
                      size="sm" 
                      @click="keepAllEvents(index)"
                    >
                      <feather-icon icon="TrashIcon" class="export-button-icon"/>
                      {{ $t('IMPORT_CALENDAR.Keep_All_Events') }}
                    </b-button>
                    <b-button 
                      variant="primary"
                      size="sm" 
                      @click="resolveConflict(index)"
                    >
                      {{ $t('IMPORT_CALENDAR.Replace') }}
                    </b-button>
                  </div> -->
                </div>
                <div v-if="event.showConflicts" >
                  <ul v-for="conflict in event.conflictEvents" :key="conflict._id">
                    <li class="conflict-event-item">
                      <!--<b-form-checkbox v-model="conflict.selected"></b-form-checkbox>-->
                      <div>
                        <strong class="event-info-title">{{ conflict.content.title.data }}</strong>
                        <br>
                        <span>{{ new Date(conflict.eventScheduleDuration_dateFrom).toLocaleString() }} - {{ new Date(conflict.eventScheduleDuration_dateTo).toLocaleString() }}</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </b-list-group-item>
            </b-list-group>
          </b-overlay>
        </div>
      </div>
    </b-card>
  </div>
</template>


<script>
import { BCard, BButton, BListGroup, BListGroupItem, BOverlay } from 'bootstrap-vue';
import Ripple from "vue-ripple-directive";
import { heightFade } from '@core/directives/animations'
import { ref, computed } from "@vue/composition-api";
import ICAL from "ical.js";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';
import newsService from '@/providers/newsService';
import convertDatetimeHelper from "@/helpers/convert-datetime-helper";

let that

export default {
  components: {
    BCard,
    BButton,
    BListGroup,
    BListGroupItem,
    BOverlay,
    //BFormCheckbox
  },
  directives: {
    Ripple,
    'height-fade': heightFade,
  },

  created() {
    that = this;
  },

  setup(props, { emit }) {

    const fileImage = ref(null); 
    const events = ref([]); 
    const isUpdate = computed(() => !!props.route?.params?.id);
    const displayOverlay = ref(false);
    const conflictingEvents = ref([]);

    const openSelectFile = () => {
      fileImage.value.click();
    };

    const onSelectedFile = async (event) => {
      const file = event.target.files[0];
      if (file && file.type === "text/calendar") {
        displayOverlay.value = true;
        try {
          const text = await readFile(file);
          const parsedEvents = parseICSFile(text);

          if (parsedEvents.length === 0) {
            messagesNotifyHelper.errorNotify(
              that.$t('IMPORT_CALENDAR.Error'),
              that.$t('IMPORT_CALENDAR.No_Events_Found')
            );
          } else {
            events.value = parsedEvents;
            checkEventConflicts();
          }
          
          events.value = parsedEvents.map(event => ({
            ...event,
            hasConflict: false,
            conflictEvents: [],
            showConflicts: false,
          }));
        } catch (error) {
          messagesNotifyHelper.errorNotify(
              that.$t('IMPORT_CALENDAR.Error'),
              that.$t('IMPORT_CALENDAR.Error_Processing_File')
            );
          console.error("Erro ao processar o arquivo .ics:", error);
        } finally {
          displayOverlay.value = false; 
          
        }
      } else {
        messagesNotifyHelper.errorNotify(
          that.$t('IMPORT_CALENDAR.Error'),
          that.$t('IMPORT_CALENDAR.Select_Valid_File')
        );
      }
    };

    const readFile = (file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsText(file);
      });
    };

    const parseICSFile = (text) => {
      const jcalData = ICAL.parse(text);
      const component = new ICAL.Component(jcalData);
      const now = new Date();
      const vevents = component.getAllSubcomponents("vevent");

      const events = [];

      vevents.forEach((vevent) => {
        const event = new ICAL.Event(vevent);

        if (event.isRecurring()) {
          const iterator = event.iterator();
          let next;
          while ((next = iterator.next())) {
            const nextDate = next.toJSDate();

            if (nextDate >= now) {
              events.push({
                summary: event.summary,
                startDate: nextDate,
                endDate: new Date(nextDate.getTime() + event.duration.toSeconds() * 1000),
                location: event.location,
                description: event.description,
                isRecurring: true,
              });
            }
          }
        } else {
          if (event.startDate.toJSDate() >= now) {
            events.push({
              summary: event.summary,
              startDate: event.startDate.toJSDate(),
              endDate: event.endDate.toJSDate(),
              location: event.location,
              description: event.description,
              isRecurring: false,
            });
          }
        }
      });
      return events.sort((a, b) => a.startDate - b.startDate);
    };


    // const parseICSFile = (text) => {
    //   const jcalData = ICAL.parse(text);
    //   const component = new ICAL.Component(jcalData);
    //   const now = new Date();

    //   return component.getAllSubcomponents("vevent")
    //     .map((vevent) => {
    //       const event = new ICAL.Event(vevent);
    //       console.log("Eventos recebidos", event);
    //       return {
    //         summary: event.summary,
    //         startDate: event.startDate.toJSDate(),
    //         endDate: event.endDate.toJSDate(),
    //         location: event.location,
    //         description: event.description,
    //       };
    //     })
    //     .filter((event) => event.startDate >= now)
    //     .sort((a, b) => a.startDate - b.startDate);
    // };

    const dragover = (event) => {
      event.preventDefault();
      event.currentTarget.classList.add("bg-dragover");
    };

    const dragleave = (event) => {
      event.currentTarget.classList.remove("bg-dragover");
    };

    const drop = (event) => {
      event.preventDefault();
      onSelectedFile(event);
      dragleave(event);
    };

    const deleteEvent = (index) => {
      events.value.splice(index, 1); 
    };
    
    const onSubmit = async () => {
      if (events.value.length === 0) {
        messagesNotifyHelper.errorNotify(
          that.$t('IMPORT_CALENDAR.Error'),
          that.$t('IMPORT_CALENDAR.No_Events_Found')
        );
        return;
      }

      try {

        const sanitizedEvents = events.value.map(event => {
          const sanitizedEvent = { ...event }; 
          delete sanitizedEvent.hasConflict; 
          delete sanitizedEvent.conflictEvents; 
          return sanitizedEvent; 
        });

        displayOverlay.value = true; 
        newsService
        .sendImportedCalendarEvents(sanitizedEvents, new URLSearchParams()) 
        .then((res) => {
          if (res) {
            messagesNotifyHelper.successNotify(
              that.$t('IMPORT_CALENDAR.Success'),
              `${res.created_events.length} ${that.$t('IMPORT_CALENDAR.Events_Created')}`
            );
            // ${res.updated_events.length} ${that.$t('IMPORT_CALENDAR.Events_Updated')}
          }
          events.value = []; 
        })
      } catch (error) {
        messagesNotifyHelper.errorNotify(
          that.$t('IMPORT_CALENDAR.Error'),
          that.$t('IMPORT_CALENDAR.Failed_To_Send_Events')
        );
      } finally {
        displayOverlay.value = false;
        emit('close')
      }
    };

    const checkEventConflicts = async () => {
      try {
        newsService
        .checkEventConflicts(events.value) 
        .then((res) => {
          if (res && res.length > 0) {
            conflictingEvents.value = res;
            events.value = events.value.map((importedEvent) => {
              const conflicts = conflictingEvents.value.filter(
                (conflict) =>
                  new Date(conflict.eventScheduleDuration_dateFrom).getTime() === importedEvent.startDate.getTime() &&
                  conflict.eventScheduleDuration_hourFrom === convertDatetimeHelper.formatTimeWithTimezoneDate(importedEvent.startDate) &&
                  new Date(conflict.eventScheduleDuration_dateTo).getTime() === importedEvent.endDate.getTime() &&
                  conflict.eventScheduleDuration_hourTo === convertDatetimeHelper.formatTimeWithTimezoneDate(importedEvent.endDate)
              );

              return {
                ...importedEvent,
                hasConflict: conflicts.length > 0,
                conflictEvents: conflicts,
              };
            });

            if (conflictingEvents.value.length > 0) {
              messagesNotifyHelper.errorNotify(
                that.$t('IMPORT_CALENDAR.Conflicts_Found')
                // that.$t('IMPORT_CALENDAR.Resolve_Conflicts_Before_Submitting')
              );
            }
          }
        })
      } catch (error) {
        console.error("Erro ao verificar conflitos:", error);
        messagesNotifyHelper.errorNotify(
          that.$t('IMPORT_CALENDAR.Error'),
          that.$t('IMPORT_CALENDAR.Failed_To_Check_Conflicts')
        );
      }
    };

    // const resolveConflict = (index) => {
    //   const importedEvent = events.value[index];

    //   const selectedConflicts = importedEvent.conflictEvents.filter(conflict => conflict.selected);

    //   importedEvent.eventIdsToReplace = selectedConflicts.map(conflict => conflict._id);

    //   importedEvent.hasConflict = false;

    //   importedEvent.conflictEvents.forEach(conflict => {
    //     conflict.selected = false;
    //   });
    // };

    // const keepAllEvents = (index) => {
    //   const importedEvent = events.value[index];

    //   importedEvent.eventIdsToReplace = [];
    //   importedEvent.hasConflict = false;
    //   importedEvent.conflictEvents = [];
    // };

    return {
      fileImage,
      events,
      displayOverlay,
      isUpdate,
      openSelectFile,
      onSelectedFile,
      dragover,
      dragleave,
      drop,
      deleteEvent, 
      onSubmit,
      checkEventConflicts,
      //resolveConflict,
      //keepAllEvents
    };
  },
}
</script>

